import dayjs from "dayjs"
import { isValidPhoneNumber } from "libphonenumber-js"
import { custom, maxLength, minLength, nonEmpty, number, pipe, string, transform, union } from "valibot"

import { isHebrew } from "@finq/ui/utils/ui.utils"

export const stripNonDigits = (value: string) => value.replace(/\D/g, "")

export const phoneNumberSchema = custom<string>((value) => {
  if (!value) return false
  return isValidPhoneNumber(value as string)
}, "validations.phoneNumberFormat")

export function generateDateOfBirthSchema({ min = 18, max = 120 }: { min?: number; max?: number } = {}) {
  return pipe(
    union(
      [
        string(),
        // If the value is a number, its a unix timestamp, so we need to convert it to a date
        pipe(
          number(),
          transform((value) => {
            const dateAsUnix = dayjs.unix(value)
            if (dateAsUnix.isValid()) return dateAsUnix.format("YYYY-MM-DD")
            return value
          })
        ),
      ],
      "validations.dateOfBirth"
    ),
    // Validate min and max age, and that its before today's date
    custom((value) => {
      if (typeof value !== "string" && typeof value !== "number") return false
      const date = dayjs(value)
      const age = dayjs().diff(date, "year")
      return age >= min && age <= max && date.isBefore(dayjs())
    }, "validations.invalidAge")
  )
}

export const dateOfBirthSchema = generateDateOfBirthSchema({ min: 18, max: 120 })

export function generateNameSchema(name: "firstName" | "lastName") {
  return pipe(
    string(`validations.${name}`),
    nonEmpty(`validations.${name}`),
    custom((value) => isHebrew(value as string), `validations.not_hebrew`),
    minLength(1, `validations.${name}_too_short`),
    maxLength(60, `validations.${name}_too_long`)
  )
}
